import React from 'react';
import { toast } from 'react-toastify';
import { call, put } from 'redux-saga/effects';

import { Creators as WebhookEventHeaderIntegration } from '../ducks/webhookEventHeaderIntegration';

import { WebhookEventHeaderIntegrationAPI } from '../../services/api';

import { ErrorToast } from '../../components/molecules/Toast';

export function* getWebhookEventHeadersList(action) {
  const { webhookEventId } = action.payload;
  try {
    const response = yield call(
      WebhookEventHeaderIntegrationAPI.get,
      `/list/${webhookEventId}`
    );
    const isSuccess = response.status === 200 || false;
    yield put(
      WebhookEventHeaderIntegration.getWebhookEventHeadersListResponse(
        response.data,
        isSuccess
      )
    );
  } catch (error) {
    yield put(
      WebhookEventHeaderIntegration.getWebhookEventHeadersListResponse(
        {},
        false
      )
    );
    toast.error(
      <ErrorToast size="30">
        {error.response.data || error.response.data.result}
      </ErrorToast>
    );
  }
}

export function* postWebhookEventHeader(action) {
  const { params } = action.payload;
  try {
    const response = yield call(
      WebhookEventHeaderIntegrationAPI.post,
      `/post`,
      params
    );
    const isSuccess = response.status === 200 || false;

    yield put(
      WebhookEventHeaderIntegration.postWebhookEventHeaderResponse(
        response.data,
        isSuccess
      )
    );
  } catch (error) {
    yield put(
      WebhookEventHeaderIntegration.postWebhookEventHeaderResponse([], false)
    );
    toast.error(
      <ErrorToast size="30">
        {error.response.data || error.response.data.result}
      </ErrorToast>
    );
  }
}

export function* deleteWebhookEventHeader(action) {
  const idWebhookEventHeader = action.payload;
  try {
    const response = yield call(
      WebhookEventHeaderIntegrationAPI.delete,
      `${idWebhookEventHeader}`
    );

    const isSuccess = response.status === 200 || false;

    yield put(
      WebhookEventHeaderIntegration.deleteWebhookEventHeaderResponse(
        response.data,
        isSuccess
      )
    );
  } catch (error) {
    yield put(
      WebhookEventHeaderIntegration.deleteWebhookEventHeaderResponse({}, false)
    );
    toast.error(
      <ErrorToast size="30">
        {error.response.data || error.response.data.result}
      </ErrorToast>
    );
  }
}

export function* putWebhookEventHeader(action) {
  const { params } = action.payload;
  try {
    const response = yield call(
      WebhookEventHeaderIntegrationAPI.put,
      `/put`,
      params
    );
    const isSuccess = response.status === 200 || false;
    yield put(
      WebhookEventHeaderIntegration.putWebhookEventHeaderResponse(
        response.data,
        isSuccess
      )
    );
  } catch (error) {
    yield put(
      WebhookEventHeaderIntegration.putWebhookEventHeaderResponse({}, false)
    );

    toast.error(
      <ErrorToast size="30">
        {error.response.data || error.response.data.result}
      </ErrorToast>
    );
  }
}
